"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var Icon_1 = require("components/Icon");
var FileIcon_1 = require("components/FileIcon");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var constants = require("../constants");
require("./node-content-renderer.scss");
function isDescendant(older, younger) {
    return (!!older.children &&
        older.children.some(function (child) { return child === younger || isDescendant(child, younger); }));
}
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('FileThemeNodeContentRenderer'), (0, recompose_1.defaultProps)({
    buttons: [],
    canDrag: false,
    canDrop: false,
    className: '',
    draggedNode: null,
    icons: [],
    isSearchFocus: false,
    isSearchMatch: false,
    parentNode: null,
    style: {},
    swapDepth: null,
    swapFrom: null,
    swapLength: null,
    title: null,
    toggleChildrenVisibility: null
}), recompose_1.pure);
var FileThemeNodeContentRenderer = function (outerProps) {
    return enhance(function (props) {
        var _a, _b;
        var rawNode = props.node.getValue();
        var type = rawNode.type || 'FOLDER';
        var isFolder = type === 'FOLDER';
        if (((outerProps.perm || 0x00) &
            (rawNode.feature || 0x00) &
            acl.SUBPROJECT_PERM) >
            0) {
            type = 'SUBPROJECT';
        }
        var belongsAutomatic = rawNode.onAutomaticOrder;
        var nodeTitle = "".concat(rawNode.name).concat(outerProps.showChildCount && rawNode.meta
            ? " (".concat(rawNode.meta.count || 0, ")")
            : '');
        var isDraggedDescendant = props.draggedNode && isDescendant(props.draggedNode, props.node);
        var isLandingPadActive = !props.didDrop && props.isDragging;
        var toggleChildrenVisibility = props.toggleChildrenVisibility;
        var hasChildrens = props.node.getChildren().length > 0;
        var expandContent = outerProps.expandType === constants.ANY_CONTENT
            ? hasChildrens || ((_b = (_a = rawNode.meta) === null || _a === void 0 ? void 0 : _a.count) !== null && _b !== void 0 ? _b : 0) > 0
            : hasChildrens || (rawNode.type === 'FOLDER' && rawNode.length !== 0);
        var showExpand = toggleChildrenVisibility && isFolder && expandContent;
        // Construct the scaffold representing the structure of the tree
        var scaffold = [];
        props.lowerSiblingCounts.forEach(function (_, i) {
            scaffold.push(React.createElement("div", { key: "pre_".concat(1 + i), style: {
                    width: props.scaffoldBlockPxWidth,
                    flexBasis: props.scaffoldBlockPxWidth
                }, className: 'sok-folder-tree-line-block' }));
            if (props.treeIndex !== props.listIndex && i === props.swapDepth) {
                // This row has been shifted, and is at the depth of
                // the line pointing to the new destination
                var highlightLineClass = '';
                if (props.listIndex ===
                    (props.swapFrom || 0) + (props.swapLength || 0) - 1) {
                    // This block is on the bottom (target) line
                    // This block points at the target block (where the row will go when released)
                    highlightLineClass = 'sok-folder-tree-highlight-bottom-left-corner';
                }
                else if (props.treeIndex === props.swapFrom) {
                    // This block is on the top (source) line
                    highlightLineClass = 'sok-folder-tree-highlight-top-left-corner';
                }
                else {
                    // This block is between the bottom and top
                    highlightLineClass = 'sok-folder-tree-highlight-line-vertical';
                }
                scaffold.push(React.createElement("div", { key: "highlight_".concat(1 + i), style: {
                        width: props.scaffoldBlockPxWidth
                    }, className: "".concat('sok-folder-tree-absolute-line-block', " ").concat(highlightLineClass) }));
            }
        });
        var nodeContent = (React.createElement("div", null,
            React.createElement("div", { className: 'sok-folder-tree-row-contents' +
                    (!props.canDrag
                        ? " ".concat('sok-folder-tree-row-wrapper-drag-disabled')
                        : '') }, props.connectDragPreview(React.createElement("div", { className: 'sok-folder-tree-row-contents-preview' },
                React.createElement("div", { className: classNames('sok-folder-tree-row', isLandingPadActive ? 'sok-folder-tree-row-landing-pad' : '', isLandingPadActive && !props.canDrop
                        ? 'sok-folder-tree-row-cancel-pad'
                        : '', props.isSearchMatch ? 'sok-folder-tree-row-search-match' : '', props.isSearchFocus ? 'sok-folder-tree-row-search-focus' : '', props.className ? props.className : '', props.node.getSelected() ? 'selected' : ''), style: __assign({ opacity: isDraggedDescendant ? 0.5 : 1 }, props.style) },
                    scaffold,
                    showExpand && (React.createElement(Icon_1.Icon, { "aria-label": props.node.getExpanded() ? 'Collapse' : 'Expand', className: classNames(props.node.getExpanded()
                            ? 'fa-chevron-up'
                            : 'fa-chevron-down', props.node.getExpanded()
                            ? 'sok-folder-tree-collapse-button'
                            : 'sok-folder-tree-expand-button', props.node.getValue()
                            .length === 0
                            ? 'sok-folder-tree-no-children'
                            : ''), onClick: function () {
                            return toggleChildrenVisibility &&
                                toggleChildrenVisibility({
                                    node: props.node,
                                    path: props.path,
                                    treeIndex: props.treeIndex
                                });
                        } })),
                    React.createElement("div", { className: classNames('sok-folder-tree-row-contents', !props.canDrag
                            ? 'sok-folder-tree-row-wrapper-drag-disabled'
                            : '') },
                        React.createElement("div", { className: 'sok-folder-tree-row-toolbar' }, props.icons &&
                            props.icons.map(function (icon, index) { return (React.createElement("div", { key: index, className: 'sok-folder-tree-toolbar-button' }, icon)); })),
                        React.createElement("div", { className: classNames('sok-folder-tree-row-label', type.toLowerCase()), onClick: function () {
                                outerProps.selectItem(props.node, !props.node.getSelected());
                            } },
                            React.createElement("span", { className: 'sok-folder-tree-row-title' },
                                belongsAutomatic ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)('component/folderTree/connectedToAutomaticOrder')) },
                                    React.createElement(Icon_1.Icon, { className: "sok-icon sok-icon-automatic-order-folder" }))) : (FileIcon_1.iconMap[type]),
                                React.createElement("span", { className: 'sok-folder-tree-row-title-label' }, nodeTitle),
                                React.createElement("span", { className: 'folder-fetching' }, props.node.getLoading() ? (React.createElement(Icon_1.Icon, { className: 'fa-spinner fa-spin' })) : ('')))),
                        React.createElement("div", { className: 'sok-folder-tree-row-toolbar' }, props.buttons &&
                            props.buttons.map(function (btn, index) { return (React.createElement("div", { key: index, className: 'sok-folder-tree-row-toolbar-button' }, btn)); })))))))));
        return props.canDrag
            ? props.connectDragSource(nodeContent, { dropEffect: 'copy' })
            : nodeContent;
    });
};
exports.default = FileThemeNodeContentRenderer;
